import { FlowContextProvider, StepWrapper } from '@betterment/js-runtime';
import { useRequiredParam } from '@betterment/shared-components/src/hooks/useRequiredParam';
import { Route, Routes, useMatch } from 'react-router-dom';

import { FormStep } from './steps/FormStep';
import { ReviewStep } from './steps/ReviewStep';
import { SellAllWarningStep } from './steps/SellAllWarningStep';
import { SuccessStep } from './steps/SuccessStep';

import { IdempotencyProviderWithFeatureRegistry } from '../RetailApp/graphql/idempotency/IdempotencyProviderWithFeatureRegistry';
import { urlBuilder } from '../Shared/urlBuilder';

export default function Controller() {
  const accountId = useRequiredParam('accountId');
  const securityId = useRequiredParam('securityId');
  const match = useMatch('/account/:accountId/sell_order/:securityId/*');
  const returnToPath = urlBuilder.appAccountSecurity.absolute({ accountId, securityId });

  return (
    <IdempotencyProviderWithFeatureRegistry featureName="financialSecuritySellOrderRequest">
      <FlowContextProvider basePath={match!.pathnameBase} routePath="" returnToPath={returnToPath}>
        <Routes>
          <Route
            path="/form"
            element={
              <StepWrapper name="form">
                {stepProps => <FormStep {...stepProps} accountId={accountId} securityId={securityId} />}
              </StepWrapper>
            }
          />
          <Route
            path="/sell-all-warning"
            element={
              <StepWrapper name="sell-all-warning">
                {stepProps => <SellAllWarningStep {...stepProps} accountId={accountId} securityId={securityId} />}
              </StepWrapper>
            }
          />
          <Route
            path="/review"
            element={
              <StepWrapper name="review">
                {stepProps => <ReviewStep {...stepProps} accountId={accountId} securityId={securityId} />}
              </StepWrapper>
            }
          />
          <Route
            path="/success"
            element={<StepWrapper name="success">{stepProps => <SuccessStep {...stepProps} />}</StepWrapper>}
          />
        </Routes>
      </FlowContextProvider>
    </IdempotencyProviderWithFeatureRegistry>
  );
}
